import React__default, { forwardRef } from 'react';
import { c as classNames, Q as FontAwesomeIcon } from './responsive-b521ac2b.js';
import { C as CircularProgress } from './mediaQueries-6282b8d3.js';

const Button = forwardRef((props, ref) => {
    var _a;
    const type = (_a = props.type) !== null && _a !== void 0 ? _a : 'button';
    const classes = classNames('Button', props.className, {
        [`Button-${props.variant}`]: props.variant && props.variant !== 'default',
        'Button-busy': props.busy,
        'Button-icon': props.icon
    });
    function onClick(event) {
        var _a;
        event.stopPropagation();
        (_a = props.onClick) === null || _a === void 0 ? void 0 : _a.call(props, event);
    }
    return React__default.createElement("button", { ref: ref, className: classes, title: props.title, "aria-label": props.ariaLabel, type: type, disabled: props.disabled || props.busy, onClick: onClick },
        props.icon && React__default.createElement(FontAwesomeIcon, { className: "Button-icon", icon: props.icon, size: "sm" }),
        props.children,
        props.busy && React__default.createElement("div", { className: "Button-busyIndicator" },
            React__default.createElement(CircularProgress, { size: 16 })));
});
Button.displayName = 'Button';

export { Button as B };
